import { gql } from '@apollo/client';

export const GET_LINKED_INCIDENTS = gql`
  query GET_LINKED_INCIDENTS($incidentId: ID!, $originatorId: ID!){
    initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
      id
      uuid
      linkedIncidents {
        id
        incidentNumber
        incidentDetail {
           id
        }
        classification {
          id
          name
        }
        sealed
        locked
        callTime
        officerIncidentSpecifics {
          primaryOfficer
          id
          officer {
            id
            deptAttribute {
              id
              stateIdNumber
              ori {
                id
                oriName
                abbreviation
              }
              badge
            }
          }
        }
      }
    }    
  }
`